import { ValidationModel, ValidationType } from "@/services/validation/types";
import { Vue } from "vue-property-decorator";

export const settingsValidators = {
    name: {
        rules: [
            { type: ValidationType.Required },
            { type: ValidationType.Min, value: 3 }
        ]
    } as ValidationModel,
    width: {
        rules: [
            { type: ValidationType.Required }
        ]
    } as ValidationModel,
    height: {
        rules: [
            { type: ValidationType.Required }
        ]
    } as ValidationModel,
    expandedWidth: {
        rules: [
            { type: ValidationType.Required }
        ]
    } as ValidationModel,
    expandedHeight: {
        rules: [
            { type: ValidationType.Required }
        ]
    } as ValidationModel,
    contentTimeout: {
        rules: [
            { type: ValidationType.Required }
        ]
    } as ValidationModel
};

// content validator helper methods

export function addContentValidators(validators: any, id: string) {
    Vue.set(validators,
        `eventName-${id}`,
        { rules: [{ type: ValidationType.Required }] } as ValidationModel);
    Vue.set(validators,
        `returnToFirstPostTime-${id}`,
        {
            rules: [
                { type: ValidationType.Required },
                { type: ValidationType.Number },
                { type: ValidationType.Min, value: 5 }
            ]
        } as ValidationModel);
}

export function removeContentValidators(validators: any, id: string) {
    Vue.delete(validators,
        `eventName-${id}`);
    Vue.delete(validators,
        `returnToFirstPostTime-${id}`);
}
